<template>
  <div>
    <div class="bg">
      <div style="padding-bottom: 30px">
        <FxedTop></FxedTop>
      </div>
    </div>

    <div class="pageTitle">
      <div class="sort"></div>
      <div class="currentLocation">当前位置：首页 > 线下培训认定</div>
    </div>

    <div class="mian">
      <div>
        <div class="navbar">
          <div v-for="(item, index) in navList" :key="index" :class="item.isShow ? 'active' : 'item'"
            @click="handleNavList(item, index)">
            {{ item.title }}
            <div v-if="item.isShow" class="line"></div>
          </div>
        </div>

        <el-form v-if="currentId != '0,1,2'" :inline="true" class="demo-form-inline">
          <el-form-item label="培训年度">
            <el-select v-model="learnYear" placeholder="培训年度">
              <el-option v-for="item in yearList" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(1)">查询</el-button>
            <el-button plain @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>

        <el-button type="primary" size="small" style="margin-bottom: 20px" @click="handleAdd">发起申报认定</el-button>
        <div style="margin-bottom: 40px; background-color: #fff">
          <el-table :data="dataList" style="width: 100%">
            <el-table-column prop="recognitionStatus" label="认证申报状态">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.recognitionStatus === 0" type="info">待申报</el-tag>
                <el-tag v-if="scope.row.recognitionStatus === 1" type="success">已提交</el-tag>
                <el-tag v-if="scope.row.recognitionStatus === 2" type="danger">审批中</el-tag>
                <el-tag v-if="scope.row.recognitionStatus === 3" type="success">审批通过</el-tag>
                <el-tag v-if="scope.row.recognitionStatus === 4" type="danger">审批不通过</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="studentName" label="申报人">
            </el-table-column>
            <el-table-column prop="applyDepartment" label="申报单位">
            </el-table-column>
            <el-table-column prop="approvalDepartment" label="审批单位">
            </el-table-column>
            <el-table-column prop="applyTime" label="申报时间">
            </el-table-column>
            <el-table-column prop="courseTitle" label="课题"> </el-table-column>
            <el-table-column prop="address" label="操作" align="center" width="300">
              <template v-slot="scope">
                <el-button type="mini" @click="handleEdit(scope.row, true)">
                  查看
                </el-button>

                <el-button v-if="
                  scope.row.recognitionStatus === 0 ||
                  scope.row.recognitionStatus === 4
                " type="mini" @click="handleEdit(scope.row, false)">
                  编辑
                </el-button>

                <el-button type="mini" @click="handleDel(scope.row, true)" v-if="
                  scope.row.recognitionStatus === 0 ||
                  scope.row.recognitionStatus === 4
                ">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div style="display: flex; justify-content: flex-end; padding-top: 20px">
            <el-pagination :page-size="pageSize" background layout="prev, pager, next" :total="total"
              @current-change="currentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="发起申报认定" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <el-form :label-position="labelPosition" label-width="110px" ref="ruleForm" :model="ruleForm" :rules="rules"
        class="demo-ruleForm">
        <div style="display: flex">
          <div style="width: 500px; margin-right: 20px">
            <el-form-item label="认定类型" prop="recognitionType">
              <el-select style="width: 100%" v-model="ruleForm.recognitionType" :disabled="disabled"
                placeholder="请选择认定类型">
                <el-option v-for="(item, index) in recognitionTypeList" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="课程科目" prop="courseTitle">
              <el-input :disabled="disabled" v-model="ruleForm.courseTitle" placeholder="请输入课程科目"></el-input>
            </el-form-item>
            <el-form-item label="举办部门" prop="department">
              <el-input :disabled="disabled" v-model="ruleForm.department" placeholder="请输入举办部门"></el-input>
            </el-form-item>
            <el-form-item label="学习地点" prop="learnLocation">
              <el-input :disabled="disabled" v-model="ruleForm.learnLocation" placeholder="请输入学习地点"></el-input>
            </el-form-item>
            <el-form-item label="学习形式" prop="learnMethod">
              <el-select :disabled="disabled" style="width: 100%" v-model="ruleForm.learnMethod" placeholder="请选择学习形式">
                <el-option v-for="(item, index) in learnMethodList" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="培训开始时间" prop="startTime">
              <el-date-picker :disabled="disabled" type="date" format="yyyy-MM-dd" placeholder="请输入培训开始时间"
                v-model="ruleForm.startTime" style="width: 100%"></el-date-picker>
            </el-form-item>
            <el-form-item label="培训结束时间" prop="endTime">
              <el-date-picker :disabled="disabled" type="date" format="yyyy-MM-dd" placeholder="请输入培训结束时间"
                v-model="ruleForm.endTime" style="width: 100%"></el-date-picker>
            </el-form-item>
            <el-form-item label="培训个人总结" prop="summaryAttachment">
              <div style="display: flex; flex-wrap: wrap; align-items: center">
                <div class="demo-image__preview" v-for="(item, index) in ruleForm.summaryAttachment" :key="index">
                  <div class="fileName" @click="showFile(item)">
                    {{ getFileName(item) }}
                  </div>
                  <div v-if="!disabled" class="imageDel" @click="delImage1(index)">
                    删除
                  </div>
                </div>
              </div>
              <upload v-if="!disabled" @handleUrl="handleUrl1" :type="'all'" :isURL="false"
                bizPath="offline_recognition" text="请上传个人总结" />
            </el-form-item>
            <el-form-item label="参训通知" prop="noticeAttachment">
              <!-- 图片自动换行 -->
              <div style="display: flex; flex-wrap: wrap; align-items: center">
                <div class="demo-image__preview" v-for="(item, index) in ruleForm.noticeAttachment" :key="index">
                  <div class="fileName" @click="showFile(item)">
                    {{ getFileName(item) }}
                  </div>
                  <div v-if="!disabled" class="imageDel" @click="delImage2(index)">
                    删除
                  </div>
                </div>
              </div>

              <upload v-if="!disabled" @handleUrl="handleUrl2" :isURL="false" bizPath="offline_recognition"
                text="请上传参训通知" />
            </el-form-item>
            <el-form-item label="结业证书" prop="certificateAttachment">
              <div style="display: flex; flex-wrap: wrap; align-items: center">
                <div class="demo-image__preview" v-for="(item, index) in ruleForm.certificateAttachment" :key="index">
                  <div class="fileName" @click="showFile(item)">
                    {{ getFileName(item) }}
                  </div>
                  <div v-if="!disabled" class="imageDel" @click="delImage3(index)">
                    删除
                  </div>
                </div>
              </div>
              <upload v-if="!disabled" @handleUrl="handleUrl3" :isURL="false" bizPath="offline_recognition"
                text="请上传结业证书" />
            </el-form-item>
            <el-form-item label="科目类别" prop="courseType">
              <el-select :disabled="disabled" style="width: 100%" v-model="ruleForm.courseType" placeholder="请选择科目类别">
                <el-option v-for="(item, index) in courseTypeList" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="预计认定学时" prop="learnHour">
              <el-input :disabled="disabled" v-model="ruleForm.learnHour" placeholder="请输入预计认定学时"></el-input>
            </el-form-item>
            <el-form-item label="培训年度" prop="learnYear">
              <el-select :disabled="disabled" style="width: 100%" v-model="ruleForm.learnYear" placeholder="请选择培训年度">
                <el-option v-for="(item, index) in yearList" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input :disabled="disabled" v-model="ruleForm.remark" placeholder="请输入备注"></el-input>
            </el-form-item>

            <el-form-item label="审批说明" prop="approvalFeedback" v-if="
              ruleForm.recognitionStatus == 4 ||
              ruleForm.recognitionStatus == 3
            ">
              <div style="color: red; line-height: 20px">
                {{ ruleForm.approvalFeedback }}
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm', '1')"
                :disabled="disabled || loading">提交申报</el-button>
              <el-button type="primary" @click="submitForm('ruleForm', '0')"
                :disabled="disabled || loading">保存草稿</el-button>
              <el-button v-if="
                ruleForm.recognitionStatus == 1 ||
                ruleForm.recognitionStatus == 3
              " :disabled="loading" type="primary" @click="undoForm()">撤销申报</el-button>
            </el-form-item>
          </div>
          <div style="flex: 1">
            <div style="font-size: 20px; font-weight: bold; margin-bottom: 20px">
              学时认定标准
            </div>
            <div style="margin-bottom: 20px">
              1、专业技术人员脱产培训参加以更新、补充、拓展专业技术知识和能力的各级各类进修、研修、培训等，以实际学习的学时认定，但每天不超过8学时，旅途和休息时间除外。
            </div>
            <div style="margin-bottom: 20px">
              2、专业技术人员参加国际学术会议、学术讲座、学术交流的，根据活动实际实有天数按每天8学时认定:参加国家部委举办的学术会议、学术讲座、学术交流的，以参加地市级以上行业主管部门或行业协会、学会组织举办的会议、学术讲座、学术交流的，根据实有天数按每天6学时认定。
            </div>
            <div style="margin-bottom: 20px">
              3、专业技术人员参加学历教育或攻读学位，凡考试合格者，每门课程按15学时认定:课程进修考核合格者，不满6个月的，按每月10学时认定，超过6个月的，可按完成年度专业科目学时认定。
            </div>
            <div style="margin-bottom: 20px">
              4、专业技术人员到生产单位或基层开展讲学、技术咨询、技术指导登服务活动的，按实有天数每天6学时认定
            </div>
            <div style="margin-bottom: 20px">
              5、参加“西藏自治区专业技术人员继续教育网”网络学习的专业技术人员，按已经规定的学时进行认定;参加其他形式的远程教育和网络学习的，如未对学时进行规定，按实有天数每天8学时认定。
            </div>
            <div style="margin-bottom: 20px">
              6、专业技术人员参加命题的，按实际天数每半天1学时认定,
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="查看" :visible.sync="isFile" width="50%" :before-close="handleFileClose">
      <template v-if="showImageUrl">
        <el-image style="width: 500px" :src="showImageUrl" :preview-src-list="[showImageUrl]">
        </el-image>
      </template>
      <template v-if="showDocxFileUrl && showDocxFileUrl.indexOf('.pdf') != -1">
        <VueOfficePdf :src="showDocxFileUrl" @rendered="renderedHandler" @error="errorHandler"></VueOfficePdf>
      </template>
      <template v-if="showDocxFileUrl && isXlsx(showDocxFileUrl)">
        <VueOfficeExcel :src="showDocxFileUrl" @rendered="renderedHandler" @error="errorHandler"></VueOfficeExcel>
      </template>
      <template v-if="showDocxFileUrl && isDocx(showDocxFileUrl)">
        <VueOfficeDocx :src="showDocxFileUrl" @rendered="renderedHandler" @error="errorHandler"></VueOfficeDocx>
      </template>
    </el-dialog>
    <Footer></Footer>
  </div>
</template>

<script>
import FxedTop from "@/components/FxedTop";
import Footer from "@/components/Footer.vue";
import upload from "@/components/upload.vue";
import VueOfficeDocx from "@vue-office/docx";
import VueOfficeExcel from "@vue-office/excel";
import VueOfficePdf from "@vue-office/pdf";
// 更灵活的版本，可以指定结束年份
function generateYearList(endYear = 2026) {
  // const currentYear = new Date().getFullYear() - 1;
  // const yearList = [];

  // for (let year = currentYear; year <= endYear; year++) {
  //   yearList.push({
  //     value: year,
  //     label: year.toString(),
  //   });
  // }
  const yearList = [{
    label: "2025",
    value: 2025,
  }];
  return yearList;
}
import {
  offlineRecognitionList,
  offlineRecognitionAdd,
  offlineRecognitionUpdate,
  offlineRecognitionWithdraw,
  offlineRecognitionDelete,
} from "@/api/wkApi";
export default {
  components: {
    Footer,
    FxedTop,
    upload,
    VueOfficeDocx,
    VueOfficeExcel,
    VueOfficePdf,
  },
  data() {
    return {
      labelPosition: "right",
      ruleForm: {
        recognitionType: undefined,
        courseTitle: undefined,
        department: undefined,
        learnLocation: undefined,
        learnMethod: undefined,
        startTime: undefined,
        endTime: undefined,
        courseType: 2,
        learnHour: undefined,
        learnYear: undefined,
        remark: undefined,
        summaryAttachment: [],
        noticeAttachment: [],
        certificateAttachment: [],
      },
      rules: {
        recognitionType: [
          { required: true, message: "请选择认定类型", trigger: "blur" },
        ],
        courseTitle: [
          { required: true, message: "请输入课程题目", trigger: "blur" },
        ],
        department: [
          { required: true, message: "请输入举办部门", trigger: "blur" },
        ],
        learnLocation: [
          { required: true, message: "请输入学习地点", trigger: "blur" },
        ],
        learnMethod: [
          { required: true, message: "请选择学习形式", trigger: "blur" },
        ],
        startTime: [
          { required: true, message: "请输入培训开始时间", trigger: "blur" },
        ],
        endTime: [
          { required: true, message: "请输入培训结束时间", trigger: "blur" },
        ],
        summaryAttachment: [
          { required: true, message: "请上传培训个人总结", trigger: "blur" },
        ],
        noticeAttachment: [
          { required: true, message: "请上传参训通知", trigger: "blur" },
        ],
        certificateAttachment: [
          { required: true, message: "请上传结业证书", trigger: "blur" },
        ],
        courseType: [
          { required: true, message: "请选择科目类别", trigger: "blur" },
        ],
        learnHour: [
          { required: true, message: "请输入预计认定学时", trigger: "blur" },
        ],
        learnYear: [
          { required: true, message: "请输入培训年度", trigger: "blur" },
        ],
      },
      // 认定类型 1=脱产形式的进修、研修、培训等 2= 国际学术会议、讲座、交流等 3=国家部委或地市级部门学术会议、讲座、交流等
      // 4= 学历教育、攻读学位 5=课程进修合格 6= 生产单位或基层开展讲学、技术咨询、技术指导等活动 7=参加命题
      recognitionTypeList: [
        { value: 1, label: "脱产形式的进修、研修、培训等" },
        { value: 2, label: "国际学术会议、讲座、交流等" },
        { value: 3, label: "国家部委或地市级部门学术会议、讲座、交流等" },
        { value: 4, label: "学历教育、攻读学位" },
        { value: 5, label: "课程进修合格" },
        { value: 6, label: "生产单位或基层开展讲学、技术咨询、技术指导等活动" },
        { value: 7, label: "参加命题" },
      ],
      // 学习形式,1=脱产培训,2=干部选学,3=网络培训,4=在职专题研修,5=其他
      learnMethodList: [
        { value: 1, label: "脱产培训" },
        { value: 2, label: "干部选学" },
        { value: 3, label: "网络培训" },
        { value: 4, label: "在职专题研修" },
        { value: 5, label: "其他" },
      ],
      // 科目类型,1=公需科目,2=专业科目
      courseTypeList: [{ value: 2, label: "专业科目" }],
      yearList: this.getYearsDesc(2016),

      dialogVisible: false,
      loading: false,
      navList: [
        {
          title: "申报认定",
          isShow: true,
          id: "0,1,2",
        },
        {
          title: "未通过认定",
          isShow: false,
          id: "4",
        },
        {
          title: "已通过认定",
          isShow: false,
          id: "3",
        },
      ],
      type: 1,
      dataList: [],
      disabled: true,
      currentId: "0,1,2",
      total: 1,
      pageSize: 10,
      learnYear: 2025,
      isFile: false,
      showImageUrl: undefined,
      showDocxFileUrl: undefined,
    };
  },
  mounted() {
    this.getList(1);
  },
  methods: {
    resetQuery() {
      this.learnYear = 2025;
      this.getList(1);
    },
    getYearsDesc(startYear = 2018) {
      const current = new Date().getFullYear();
      const years = [];
      for (let y = current; y >= startYear; y--) years.push(y);
      return years;
    },
    isImageUrl(url) {
      // 图片格式数组
      let imgArr = [
        ".png",
        ".jpg",
        ".jpeg",
        ".gif",
        ".bmp",
        ".webp",
        ".svg",
        ".ico",
      ];
      return imgArr.some((ext) => url.toLowerCase().endsWith(ext));
    },
    // 判定是否为表格
    isXlsx(url) {
      // 图片格式数组
      let imgArr = [".xls", ".xlsx", ".csv", ".tsv", ".ods", ".xlsb", ".xlsm"];
      return imgArr.some((ext) => url.toLowerCase().endsWith(ext));
    },
    isDocx(url) {
      let imgArr = [".doc", ".docx", ".odt", ".rtf", ".txt", ".md", ".wps"];
      return imgArr.some((ext) => url.toLowerCase().endsWith(ext));
    },
    showFile(url) {
      /**
       * 1.如果是图片格式, 则查看图片
       * 2.如果是其他类型文件则下载
       * 3.根据链接后缀判断
       */

      if (this.isImageUrl(url)) {
        this.showDocxFileUrl = undefined;
        this.showImageUrl = url;
        this.isFile = true;
      } else {
        // this.showImageUrl = undefined;
        // this.showDocxFileUrl = url;
        this.isFile = false;
        window.open(url);
      }
    },
    renderedHandler() {
      console.log("文档渲染完成");
    },
    errorHandler(e) {
      console.error("渲染失败", e);
    },
    handleFileClose() {
      this.isFile = false;
    },
    handleAdd() {
      this.ruleForm = {
        recognitionType: undefined,
        courseTitle: undefined,
        department: undefined,
        learnLocation: undefined,
        learnMethod: undefined,
        startTime: undefined,
        endTime: undefined,
        courseType: 2,
        learnHour: undefined,
        learnYear: undefined,
        remark: undefined,
        summaryAttachment: [],
        noticeAttachment: [],
        certificateAttachment: [],
      };
      this.dialogVisible = true;
      this.disabled = false;
    },
    // 返回图片名称
    getFileName(url) {
      // 获取文件名称,  https://blog.csdn.net/qq_41951205/article/details/104051907.png
      return url.substring(url.lastIndexOf("/") + 1);
    },

    currentChange(envt) {
      this.getList(envt);
    },
    async handleDel(row) {
      try {
        await this.$confirm("是否确认删除");
        const res = await offlineRecognitionDelete(row);
        if (res.code == 200) {
          this.$message.success("删除成功");
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      } catch {
        this.$message.error(res.message);
      }
    },
    getList(envt) {
      let params = {
        recognitionStatus: this.currentId,
        pageSize: this.pageSize,
        pageNo: envt ? envt : 1,
        learnYear: this.learnYear,
      }
      if (this.currentId == '0,1,2') {
        delete params.learnYear
      }
      offlineRecognitionList(params).then((res) => {
        this.dataList = res.result.records;
        this.total = res.result.total;
      });
    },
    handleUrl1(url) {
      this.ruleForm.summaryAttachment.push(url);
    },
    handleUrl2(url) {
      this.ruleForm.noticeAttachment.push(url);
    },
    handleUrl3(url) {
      this.ruleForm.certificateAttachment.push(url);
    },
    delImage1(idx) {
      // 删除图片
      this.ruleForm.summaryAttachment.splice(idx, 1);
    },
    delImage2(idx) {
      // 删除图片
      this.ruleForm.noticeAttachment.splice(idx, 1);
    },
    delImage3(idx) {
      // 删除图片
      this.ruleForm.certificateAttachment.splice(idx, 1);
    },
    submitForm(formName, recognitionStatus) {
      this.$refs[formName].validate(async (valid) => {
        // 判断learnHour是否为数字
        if (isNaN(this.ruleForm.learnHour)) {
          this.$message.error("预计认定学时只能为数字");
          return;
        }
        if (valid) {
          this.loading = true;
          if (this.ruleForm.endTime) {
            this.ruleForm.endTime = formatDateToYYYYMMDD(this.ruleForm.endTime);
          }
          if (this.ruleForm.startTime) {
            this.ruleForm.startTime = formatDateToYYYYMMDD(
              this.ruleForm.startTime
            );
          }
          let summaryAttachment = this.ruleForm.summaryAttachment.join(",");
          let noticeAttachment = this.ruleForm.noticeAttachment.join(",");
          let certificateAttachment =
            this.ruleForm.certificateAttachment.join(",");
          if (this.ruleForm.id) {
            const res = await offlineRecognitionUpdate({
              ...this.ruleForm,
              summaryAttachment,
              noticeAttachment,
              certificateAttachment,
              recognitionStatus,
            });
            if (res.code === 200) {
              if (recognitionStatus == 1) {
                this.$message.success("提交申报成功");
              } else {
                this.$message.success("保存草稿成功");
              }
              this.dialogVisible = false;
              this.getList(1);
            } else {
              this.$message.error(res.message);
            }
          } else {
            const res = await offlineRecognitionAdd({
              ...this.ruleForm,
              summaryAttachment,
              noticeAttachment,
              certificateAttachment,
              recognitionStatus,
            });
            if (res.code === 200) {
              if (recognitionStatus == 1) {
                this.$message.success("提交申报成功");
              } else {
                this.$message.success("保存草稿成功");
              }
              this.dialogVisible = false;
              this.getList(1);
            } else {
              this.$message.error(res.message);
            }
          }
          this.loading = false;
        }
      });
    },
    async undoForm() {
      this.loading = true;
      const res = await offlineRecognitionWithdraw(this.ruleForm);
      if (res.code === 200) {
        this.$message.success("撤销申报成功");
        this.loading = false;
        this.dialogVisible = false;
        this.getList(1);
      } else {
        this.loading = false;
        this.$message.error(res.message);
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleNavList(item, index) {
      this.navList.forEach((item) => {
        item.isShow = false;
      });
      this.type = index + 1;
      item.isShow = true;
      this.loading = false;
      this.total = 0;
      this.currentId = item.id;

      this.getList(1);
    },
    handleEdit(row, disabled) {
      this.ruleForm = row || {};
      if (row.certificateAttachmentList) {
        this.$set(row, "certificateAttachment", row.certificateAttachmentList);
      }
      if (row.noticeAttachmentList) {
        this.$set(row, "noticeAttachment", row.noticeAttachmentList);
      }
      if (row.summaryAttachmentList) {
        this.$set(row, "summaryAttachment", row.summaryAttachmentList);
      }
      this.disabled = disabled;
      this.dialogVisible = true;
      this.$forceUpdate();
    },
  },
};
function formatDateToYYYYMMDD(isoString) {
  // 如果已经是 YYYY-MM-DD 格式，直接返回
  if (/^\d{4}-\d{2}-\d{2}$/.test(isoString)) {
    return isoString;
  }
  const date = new Date(isoString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}
</script>

<style lang="scss" scoped>
.demo-image__preview {
  width: 100%;
  margin-right: 8px;
  line-height: 22px;
  margin-bottom: 4px;
  position: relative;

  .imageDel {
    position: absolute;
    text-align: center;
    width: 40px;
    height: 20px;
    top: 0;
    line-height: 20px;
    right: 5px;
    bottom: 5px;
    color: red;
    cursor: pointer;
    background: #fff;
    border: 1px solid red;
  }
}

.fileName {
  color: #183c70;
  text-decoration: underline;
  cursor: pointer;
}
</style>
